<template>
  <div class="page map-area-container h-full relative bg-neutral2 flex overflow-hidden" v-touch:start="onTouch">
    <div class="sidebar flex relative overflow-hidden" :class="{'basis-1/3 grow-1 shrink-0': hasSidebar, 'basis-0 grow-0': !hasSidebar}">
      <WFTabs :activeTab="mapTab" class="grow" v-if="hasSidebar">
        <WFTab name="poi">
          <POI :poi="currentPOI" @onPOIClick="showOnMap"></POI>
        </WFTab>
        <WFTab name="offer">
          <OfferDetail :offer="currentOffer" @onPOIClick="showOnMap"></OfferDetail>
        </WFTab>
        <WFTab name="instructions">
          <MapInstructions :poi="currentPOI"></MapInstructions>
        </WFTab>
      </WFTabs>
      <div v-if="hasSidebar" @click="closeSidebar" class="absolute bottom-10 right-0 bg-white w-56 h-56 back-button flex items-center content-center">
        <WFIcon class="h-6 w-12 m-auto" name="back"></WFIcon>
      </div>
    </div>
    <div class="grow-1 shrink-1 overflow-hidden relative" :class="{'basis-2/3': hasSidebar, 'basis-full': !hasSidebar}">
      <WFMap
        :project="$WF_PROJECT"
        ref="map"
        @loaded="mapLoaded"
        class="h-full"
      >
      </WFMap>
      
      <!-- Directions Panel -->
      <DirectionsPanel 
        @routeShown="onRouteShown"
        @routeCleared="onRouteCleared"
      />
      
      <div class="absolute bottom-38 right-24 right-menu flex flex-col gap-16 overflow-hidden">
        <div class="th-btn-group flex flex-col">
          <WFYAH :showLabel="false" class="wf-list-item"></WFYAH>
        </div>
        <WFShortcutsMenu 
          v-if="landscape"
          class="th-btn-group"
          :showLabel="false"
        ></WFShortcutsMenu>
        <WFFloorsMenu
          class="map-floors-menu th-btn-group"
          :currentFloor="currentFloor"
        />
      </div>
      <Map360 v-if="map360" :url="map360" @close="close360"></Map360>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Map360 from "./Map360.vue";
import POI from "./POI.vue";
import OfferDetail from "./OfferDetail.vue";
import MapInstructions from "./MapInstructions.vue";
import DirectionsPanel from "./DirectionsPanel.vue";

export default {
  computed: {
    ...mapState(["currentPOI", "log", "map360", "currentOffer", "mapTab", "reset"]),
    ...mapState("wf", ["language", "currentFloor", "reset", "portrait", "landscape"]),
    hasSidebar () {
      return !!this.currentPOI || !!this.currentOffer;
    }
  },
  components: {
    Map360,
    POI,
    OfferDetail,
    MapInstructions,
    DirectionsPanel
  },
  data() {
    return {
      generalInfo: false,
      busTimes: false, 
    };
  },
  mounted() {
    if(this.$wayfinder) {
      let upscale = parseFloat(this.$wayfinder.options.upscale);
      if (upscale > 1 ) {
        upscale = 1.2;
      }
      else if (upscale < 1) {
        upscale = 0.6;
       }

      this.$wayfinder.options.upscale = upscale;
      console.log('upscale set to', this.$wayfinder.options.upscale);
    }
  },
  watch: {
    currentPOI() {
      if (this.currentPOI && this.$refs.map) {
        this.$refs.map.showPOIPopup(this.currentPOI, 320);
        this.busTimes = false;
        this.generalInfo = false;
      }
    },
    reset() {
      this.busTimes = false;
      this.generalInfo = false;
      if(this.$wayfinder) {
        setTimeout(() => {
          this.$wayfinder.resize();
        }, 300);
      }
    },
    hasSidebar() {
      setTimeout(() => {
        this.$wayfinder.resize();
      }, 300);
    }
  },
  methods: {
    mapLoaded() {
      this.$wayfinder.events.on("map-click", (poi) => {
        console.log('wf0', this.$wayfinder)
        this.$store.dispatch("setPOI", this.$store.getters["wf/freezePOI"](poi));
        this.$store.dispatch("setNavbar", true);
      });

      this.$wayfinder.events.on("path-start", () => {
        this.busTimes = false;
        this.generalInfo = false;
      });

      this.$emit("loaded");
    },
    getPOIImage(poi) {
      if (poi.getBackgroundUrl()) return poi.getBackgroundUrl();
      else if (poi.getIconUrl()) {
        return poi.getIconUrl();
      } else {
        return "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=";
      }
    },
    isPOIImage(poi) {
      if (poi.getBackgroundUrl()) return "image-background";
      else if (poi.getIconUrl()) return "image-logo";
      else return "image-none";
    },
    closePOI() {
      this.$store.dispatch("setPOI", null);
    },
    close360() {
      this.$store.dispatch("set360", "");
    },
    showOnMap () {
      if (this.currentPOI) {
        this.$wayfinder.display(this.currentPOI);
      }
    },
    showPath() {
      if (this.currentPOI) {
        this.$wayfinder.showPath(this.currentPOI.getNode(), this.currentPOI);
      }
    },
    closePopup() {
      if (this.$refs.map) {
        this.$refs.map.hidePOIPopup();
      }
    },
    showGeneralInfo() {
      return () => {
        this.generalInfo = !this.generalInfo;
        this.busTimes = false;
        this.$refs.map.hidePOIPopup();
      };
    },
    showBusTimes() {
      return () => {
        this.busTimes = !this.busTimes;
        this.generalInfo = false;
        this.$refs.map.hidePOIPopup();
      };
    },
    onTouch() {
      this.$wayfinder.run();
    },
    closeSidebar () {
       this.$emit("closeSidebar");
    },
    // Directions panel events
    onRouteShown(routeData) {
      console.log('Route shown:', routeData.start.getName(), '→', routeData.end.getName());
      // Close any open sidebar when route is shown
      this.$store.dispatch("setPOI", null);
      this.$store.dispatch("setNavbar", false);
    },
    onRouteCleared() {
      console.log('Route cleared');
    }
  },
};
</script>

<style lang="postcss">
.sidebar {
  transition-property: flex-basis;
  transition-duration: 300ms;
  transition-delay: 100ms;
}

.wf-browser {
  //height: 145% !important;
  user-select: none;
}

.wf-browser iframe {
  user-select: none;
}

.wf-poi-popup {
  border-radius: 1.2rem;
  padding: 0 !important;
  width: 27rem !important;
  box-shadow: 0px 24px 24px 0px rgba(0, 0, 0, 0.09);
}

.wf-floors-menu .wf-list {
  display: flex;
  flex-direction: column;

  .wf-list-item {
      padding: 1.4rem;
      font-weight: 700;
      line-height: 1.4;
      
      label {
        padding-top: 0.2rem;
      }
  }
}

.wf-yah {
  padding: 1rem;
}

.general-info {
  background-color: rgba(255, 255, 255, 0.4);
}

.wf-shortcuts-menu .wf-list {
  display: flex;
  flex-direction: column;
}

.wf-shortcuts-menu .wf-list-item:active {
  background-color: var(--th-primary);

  img {
    filter: invert(1);
  }
}

.wf-yah:active {
  background-color: var(--th-primary);
}

.back-button {
  margin-right: -5.6rem;
  z-index: 4;
  border-color: var(--th-border);
  border-top: 0.1rem;
  border-bottom: 0.1rem;
  border-right: 0.1rem;
}
</style>